<template>
  <div id="login-form-component">
    <div class="w-full max-w-xl p-6 space-y-8 m-auto sm:p-8 bg-white rounded-lg shadow dark:bg-gray-800">
      <h2 class="text-2xl font-bold text-gray-900 dark:text-white">
        Sign in to platform
      </h2>
      <form @submit.prevent="handleLogin" class="mt-8 space-y-6">
        <div>
          <label for="identifier" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Email or Username</label>
          <input v-model="identifier" type="text" id="identifier" class="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500" placeholder="Email or Username" required>
        </div>
        <div>
          <label for="password" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Your password</label>
          <input v-model="password" type="password" id="password" placeholder="••••••••" class="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500" required>
        </div>
        <div class="flex items-start flex-wrap">
          <div class="flex items-center h-5">
            <input type="checkbox" v-model="remember" id="remember" class="w-4 h-4 border-gray-300 rounded bg-gray-50 focus:ring-3 focus:ring-primary-300 dark:focus:ring-primary-600 dark:ring-offset-gray-800 dark:bg-gray-700 dark:border-gray-600">
          </div>
          <div class="ml-3 text-sm">
            <label for="remember" class="font-medium text-gray-900 dark:text-white">Remember me</label>
          </div>
          <a @click.prevent="goToResetPassword" href="/reset-password" class="ml-auto mt-4 text-left text-sm text-primary-700 hover:underline dark:text-primary-500 w-full cursor-pointer">Lost Password?</a>
        </div>
        <button type="submit" class="w-full px-5 py-3 text-base font-medium text-center text-white bg-primary-700 rounded-lg hover:bg-primary-800 focus:ring-4 focus:ring-primary-300 sm:w-auto dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800">Login to your account</button>
      </form>
      <div class="text-sm font-medium text-gray-500 dark:text-gray-400">
        Not registered? <a href="/register" class="text-primary-700 hover:underline dark:text-primary-500">Create account</a>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      identifier: '', // Email or Username
      password: '',
      remember: false,
    };
  },
  methods: {
    async handleLogin() {
      try {
        const response = await axios.post('/wp-json/jwt-auth/v1/token', {
          username: this.identifier,
          password: this.password,
        });

        console.log('Logged in successfully:', response.data);

        // Store the token
        localStorage.setItem('token', response.data.token);

        // Programmatically log the user in via the custom endpoint
        const loginResponse = await axios.post('/wp-json/custom/v1/login', {
          token: response.data.token,
        });

        console.log(loginResponse.data);

        // Redirect to wp-admin or another protected area
        window.location.href = '/';

      } catch (error) {
        console.error('Login failed:', error.response ? error.response.data : error.message);
        alert('Login failed: ' + (error.response ? error.response.data.message : error.message));
      }
    },

    async goToResetPassword() {
      const resetUrls = [
        '/reset-password/',
        '/reset-password',
        '/?pagename=reset-password',
        '/index.php/reset-password/'
      ];

      // Try to check if the page exists by testing the URL
      for (const url of resetUrls) {
        try {
          const response = await fetch(url, { method: 'HEAD' });
          if (response.ok || response.status === 200) {
            window.location.href = url;
            return;
          }
        } catch (error) {
          console.log(`URL ${url} not accessible:`, error);
        }
      }

      // If none of the URLs work, show an error
      alert('Reset password page not found. Please make sure the page exists.');
      console.error('Reset password page not accessible at any of these URLs:', resetUrls);
    },
  }
};
</script>

<style scoped>
/* Add custom styles here */
</style>
